'use client';

import { c as _c } from "react/compiler-runtime";
import { Zap, MessageCircle, Building2, Wallet, GitBranch, ThumbsUp, AlertCircle } from 'lucide-react';

/* Node positions — 132px wide nodes with 38px connector gaps */
const nodes = [{
  icon: Zap,
  colour: '#00d4aa',
  label: 'Customer Invite',
  sublabel: 'Referral link sent',
  left: 18,
  top: 147
}, {
  icon: MessageCircle,
  colour: '#8b5cf6',
  label: 'Penny AI Chat',
  sublabel: 'Expanding Affordability Access',
  left: 188,
  top: 147
}, {
  icon: Building2,
  colour: '#0d9488',
  label: 'Open Banking',
  sublabel: 'Accurate Bank Data',
  left: 358,
  top: 147
}, {
  icon: Wallet,
  colour: '#10b981',
  label: 'Budget Assessment',
  sublabel: 'Data Driven Assessment',
  left: 528,
  top: 147
}, {
  icon: ThumbsUp,
  colour: '#22c55e',
  label: 'Client Assessment',
  sublabel: 'Outcome delivered',
  left: 798,
  top: 52
}, {
  icon: AlertCircle,
  colour: '#f59e0b',
  label: 'Seamless Debt Advice Referral',
  sublabel: 'Amber case flagged',
  left: 798,
  top: 255
}];
const keyframesCSS = `
@keyframes wf-float {
  0%, 100% { transform: perspective(1200px) rotateX(6deg) rotateY(-4deg) translateY(0px); }
  50%       { transform: perspective(1200px) rotateX(6deg) rotateY(-4deg) translateY(-14px); }
}
@keyframes wf-node-float {
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-5px); }
}
@keyframes wf-dash-flow {
  to { stroke-dashoffset: -26; }
}
@keyframes wf-pulse-glow {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}
@keyframes wf-label-fade {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}
@media (max-width: 767px) {
  .wf-diagram { animation: none !important; transform: none !important; }
  .wf-stage   { display: none !important; }
  .wf-mobile  { display: flex !important; }
}
@media (min-width: 768px) {
  .wf-mobile { display: none !important; }
}
`;
export default function WorkflowHeroViz() {
  const $ = _c(45);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      animation: "wf-float 7s ease-in-out infinite",
      transformStyle: "preserve-3d"
    };
    t1 = <style dangerouslySetInnerHTML={{
      __html: keyframesCSS
    }} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "relative",
      height: 450,
      maxWidth: 980,
      width: "95vw"
    };
    t3 = {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      overflow: "visible",
      zIndex: 10
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <filter id="wf-glow" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="5" result="blur" /><feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge></filter>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <linearGradient id="g0" gradientUnits="userSpaceOnUse" x1="150" y1="0" x2="188" y2="0"><stop offset="0%" stopColor="#00d4aa" /><stop offset="100%" stopColor="#8b5cf6" /></linearGradient>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <linearGradient id="g1" gradientUnits="userSpaceOnUse" x1="320" y1="0" x2="358" y2="0"><stop offset="0%" stopColor="#8b5cf6" /><stop offset="100%" stopColor="#0d9488" /></linearGradient>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <linearGradient id="g2" gradientUnits="userSpaceOnUse" x1="490" y1="0" x2="528" y2="0"><stop offset="0%" stopColor="#0d9488" /><stop offset="100%" stopColor="#10b981" /></linearGradient>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <defs>{t4}{t5}{t6}{t7}<linearGradient id="g3" gradientUnits="userSpaceOnUse" x1="660" y1="0" x2="698" y2="0"><stop offset="0%" stopColor="#10b981" /><stop offset="100%" stopColor="#f59e0b" /></linearGradient></defs>;
    t9 = <path d="M 150 229 L 188 229" fill="none" stroke="url(#g0)" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M 150 229 L 188 229" fill="none" stroke="url(#g0)" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <circle r={5.5} fill="#00d4aa" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp0" /></animateMotion></circle>;
    t12 = <path id="mp0" d="M 150 229 L 188 229" fill="none" />;
    t13 = <path d="M 320 229 L 358 229" fill="none" stroke="url(#g1)" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <path d="M 320 229 L 358 229" fill="none" stroke="url(#g1)" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  let t16;
  let t17;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <circle r={5.5} fill="#8b5cf6" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp1" /></animateMotion></circle>;
    t16 = <path id="mp1" d="M 320 229 L 358 229" fill="none" />;
    t17 = <path d="M 490 229 L 528 229" fill="none" stroke="url(#g2)" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <path d="M 490 229 L 528 229" fill="none" stroke="url(#g2)" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  let t20;
  let t21;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <circle r={5.5} fill="#0d9488" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp2" /></animateMotion></circle>;
    t20 = <path id="mp2" d="M 490 229 L 528 229" fill="none" />;
    t21 = <path d="M 660 229 L 698 229" fill="none" stroke="url(#g3)" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[19] = t19;
    $[20] = t20;
    $[21] = t21;
  } else {
    t19 = $[19];
    t20 = $[20];
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <path d="M 660 229 L 698 229" fill="none" stroke="url(#g3)" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  let t24;
  let t25;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <circle r={5.5} fill="#10b981" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp3" /></animateMotion></circle>;
    t24 = <path id="mp3" d="M 660 229 L 698 229" fill="none" />;
    t25 = <path d="M 760 229 C 780 229 798 130 798 110" fill="none" stroke="#22c55e" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[23] = t23;
    $[24] = t24;
    $[25] = t25;
  } else {
    t23 = $[23];
    t24 = $[24];
    t25 = $[25];
  }
  let t26;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <path id="mp4" d="M 760 229 C 780 229 798 130 798 110" fill="none" stroke="#22c55e" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <circle r={5.5} fill="#22c55e" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp4" /></animateMotion></circle>;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  let t29;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <text x={770} y={148} fontSize={10} fill="rgba(34,197,94,0.9)" fontFamily="monospace" fontWeight="700" style={{
      animation: "wf-label-fade 2s ease-in-out infinite"
    }}>Approved</text>;
    t29 = <path d="M 760 229 C 780 229 798 290 798 313" fill="none" stroke="#f59e0b" strokeWidth={3.5} opacity={0.35} filter="url(#wf-glow)" strokeLinecap="round" />;
    $[28] = t28;
    $[29] = t29;
  } else {
    t28 = $[28];
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <path id="mp5" d="M 760 229 C 780 229 798 290 798 313" fill="none" stroke="#f59e0b" strokeWidth={3.5} strokeDasharray="9 5" strokeLinecap="round" style={{
      animation: "wf-dash-flow 1.8s linear infinite"
    }} />;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <circle r={5.5} fill="#f59e0b" filter="url(#wf-glow)"><animateMotion dur="1.8s" repeatCount="indefinite"><mpath href="#mp5" /></animateMotion></circle>;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  let t33;
  let t34;
  let t35;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <svg style={t3}>{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}<text x={770} y={245} fontSize={10} fill="rgba(245,158,11,0.9)" fontFamily="monospace" fontWeight="700" style={{
        animation: "wf-label-fade 2s ease-in-out infinite 0.5s"
      }}>Review</text></svg>;
    t33 = {
      position: "absolute",
      left: 698,
      top: 198,
      width: 62,
      height: 62,
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    t34 = <div style={{
      position: "absolute",
      width: 53,
      height: 53,
      background: "rgba(245,158,11,0.20)",
      border: "1.5px solid rgba(245,158,11,0.80)",
      borderRadius: 7,
      transform: "rotate(45deg)",
      boxShadow: "0 0 24px rgba(245,158,11,0.3)"
    }} />;
    t35 = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 3
    };
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
  } else {
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="wf-stage" style={t2}>{t32}<div style={t33}>{t34}<div style={t35}><GitBranch style={{
            width: 16,
            height: 16,
            color: "#f59e0b"
          }} /><span style={{
            fontSize: 9,
            fontWeight: 700,
            color: "#f59e0b",
            fontFamily: "monospace",
            whiteSpace: "nowrap"
          }}>Connect</span></div></div>{nodes.map(_temp)}</div>;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  let t38;
  let t39;
  let t40;
  let t41;
  let t42;
  let t43;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = {
      display: "none",
      flexDirection: "column",
      alignItems: "stretch",
      padding: "0 16px",
      maxWidth: 420,
      margin: "0 auto"
    };
    t38 = nodes.slice(0, 4).map(_temp2);
    t39 = <div style={{
      width: 2,
      height: 20,
      background: `linear-gradient(to bottom, ${nodes[3].colour}, ${nodes[4].colour})`,
      margin: "0 auto"
    }} />;
    t40 = {
      display: "flex",
      justifyContent: "center",
      margin: "8px auto"
    };
    t41 = {
      position: "relative",
      width: 60,
      height: 60,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    t42 = <div style={{
      position: "absolute",
      width: 53,
      height: 53,
      background: "rgba(8,12,28,0.92)",
      border: "1.5px solid",
      borderColor: nodes[3].colour,
      borderRadius: 7,
      transform: "rotate(45deg)",
      boxShadow: `0 0 24px ${nodes[3].colour}40, 0 0 12px ${nodes[4].colour}30`
    }} />;
    t43 = {
      position: "relative",
      transform: "rotate(0deg)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2
    };
    $[37] = t37;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
    $[42] = t42;
    $[43] = t43;
  } else {
    t37 = $[37];
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
    t42 = $[42];
    t43 = $[43];
  }
  let t44;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="wf-diagram" style={t0}>{t1}{t36}<div className="wf-mobile" style={t37}>{t38}{t39}<div style={t40}><div style={t41}>{t42}<div style={t43}><GitBranch style={{
                width: 14,
                height: 14,
                color: nodes[3].colour
              }} /><span style={{
                fontSize: 10,
                fontWeight: 700,
                color: "white",
                fontFamily: "monospace",
                whiteSpace: "nowrap"
              }}>Connect</span></div></div></div><div style={{
          width: 2,
          height: 16,
          background: `linear-gradient(to bottom, ${nodes[3].colour}, rgba(255,255,255,0.2))`,
          margin: "0 auto"
        }} /><div style={{
          display: "flex",
          gap: 12
        }}>{nodes.slice(4).map(_temp3)}</div></div></div>;
    $[44] = t44;
  } else {
    t44 = $[44];
  }
  return t44;
}
function _temp3(node_1) {
  const Icon_1 = node_1.icon;
  return <div key={node_1.label} style={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    background: "rgba(8,12,28,0.92)",
    border: `1px solid ${node_1.colour}80`,
    borderRadius: 14,
    padding: "10px 12px",
    boxShadow: `0 4px 20px rgba(0,0,0,0.4), 0 0 0 1px ${node_1.colour}40`
  }}><div style={{
      width: 38,
      height: 38,
      borderRadius: 10,
      flexShrink: 0,
      background: `${node_1.colour}30`,
      border: `1px solid ${node_1.colour}60`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}><Icon_1 style={{
        width: 18,
        height: 18,
        color: node_1.colour
      }} /></div><p style={{
      fontSize: 12,
      fontWeight: 600,
      color: "white",
      textAlign: "center",
      margin: 0
    }}>{node_1.label}</p><p style={{
      fontSize: 10,
      color: "rgba(255,255,255,0.65)",
      textAlign: "center",
      margin: 0
    }}>{node_1.sublabel}</p></div>;
}
function _temp2(node_0, i_0) {
  const Icon_0 = node_0.icon;
  const nextColour = i_0 < 3 ? nodes[i_0 + 1].colour : undefined;
  return <div key={node_0.label} style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }}><div style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
      background: "rgba(8,12,28,0.92)",
      border: `1px solid ${node_0.colour}80`,
      borderRadius: 14,
      padding: "14px 16px",
      boxShadow: `0 4px 20px rgba(0,0,0,0.4), 0 0 0 1px ${node_0.colour}40`
    }}><div style={{
        width: 44,
        height: 44,
        borderRadius: 11,
        flexShrink: 0,
        background: `${node_0.colour}30`,
        border: `1px solid ${node_0.colour}60`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}><Icon_0 style={{
          width: 22,
          height: 22,
          color: node_0.colour
        }} /></div><div><p style={{
          fontSize: 14,
          fontWeight: 600,
          color: "white",
          margin: 0
        }}>{node_0.label}</p><p style={{
          fontSize: 11,
          color: "rgba(255,255,255,0.65)",
          margin: "2px 0 0"
        }}>{node_0.sublabel}</p></div></div>{nextColour && <div style={{
      width: 2,
      height: 20,
      background: `linear-gradient(to bottom, ${node_0.colour}, ${nextColour})`,
      margin: "0 auto"
    }} />}</div>;
}
function _temp(node, i) {
  const Icon = node.icon;
  return <div key={node.label} style={{
    position: "absolute",
    left: node.left,
    top: node.top,
    width: 132,
    height: 165,
    justifyContent: "center",
    background: "rgba(8,12,28,0.92)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    border: `1px solid ${node.colour}80`,
    borderRadius: 16,
    padding: "14px 12px",
    boxShadow: `0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px ${node.colour}40, 0 0 28px ${node.colour}30`,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: 8,
    animation: "wf-node-float 3s ease-in-out infinite",
    animationDelay: `${i * 0.35}s`,
    zIndex: 2
  }}><div style={{
      position: "absolute",
      top: 10,
      right: 10,
      width: 9,
      height: 9,
      borderRadius: "50%",
      backgroundColor: node.colour,
      boxShadow: `0 0 8px ${node.colour}`,
      animation: i === 1 ? "wf-pulse-glow 2s ease-in-out infinite" : undefined
    }} />{i === 4 && <span style={{
      fontSize: 9,
      fontWeight: 700,
      color: "#22c55e",
      background: "rgba(34,197,94,0.15)",
      border: "1px solid rgba(34,197,94,0.35)",
      borderRadius: 99,
      padding: "2px 8px",
      fontFamily: "monospace"
    }}>✓ APPROVED</span>}{i === 5 && <span style={{
      fontSize: 9,
      fontWeight: 700,
      color: "#f59e0b",
      background: "rgba(245,158,11,0.15)",
      border: "1px solid rgba(245,158,11,0.35)",
      borderRadius: 99,
      padding: "2px 8px",
      fontFamily: "monospace"
    }}>⚡ REVIEW</span>}<div style={{
      width: 52,
      height: 52,
      borderRadius: 13,
      background: `${node.colour}30`,
      border: `1px solid ${node.colour}60`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: `0 0 14px ${node.colour}50`
    }}><Icon style={{
        width: 24,
        height: 24,
        color: node.colour
      }} /></div><p style={{
      fontSize: 13,
      fontWeight: 600,
      color: "white",
      textAlign: "center",
      margin: 0
    }}>{node.label}</p><p style={{
      fontSize: 10,
      color: "rgba(255,255,255,0.70)",
      textAlign: "center",
      margin: 0
    }}>{node.sublabel}</p></div>;
}